import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  getDefaultSitePage,
  sitePageUrl,
} from 'core-components/sitebuilder/layout/helpers/sitePages'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { selectCurrentSitePageId } from 'core-components/sitebuilder/store/selectors/selectCurrentSitePageId'
import { selectRoles } from 'core-components/sitebuilder/store/selectors/selectRoles'
import { selectSitePages } from 'core-components/sitebuilder/store/selectors/selectSitePages'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { setCurrentSitePageId } from 'core-components/sitebuilder/store/siteBuilderSlice'

import { getRedirectUrl } from './helpers/getRedirectUrl'

interface IUseSitePage {
  id?: string
}

export const useInitPage = ({ id }: IUseSitePage) => {
  const [isInit, setIsInit] = useState<boolean>(false)
  const user = useSelector(selectUser)
  const roles = useSelector(selectRoles)
  const currentSitePageId = useSelector(selectCurrentSitePageId)
  const sitePages = useSelector(selectSitePages)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!sitePages) {
      navigate('/')
      return
    }
    const sitePage = id
      ? sitePages.find((i) => i.id === id)
      : getDefaultSitePage(sitePages, user, roles)

    if (sitePage) {
      if (sitePage.redirectTo) {
        const sitePageRedirect = sitePages.find((i) => i.id === (sitePage as ISitePage).redirectTo)
        if (sitePageRedirect) {
          const newUrl = sitePageUrl(sitePageRedirect)
          const calculatedRedirectUrl = getRedirectUrl(newUrl, sitePage)
          navigate(calculatedRedirectUrl)
          return
        }
      }
      if (currentSitePageId !== sitePage.id) {
        dispatch(setCurrentSitePageId(sitePage.id))
      }
    } else {
      dispatch(setCurrentSitePageId(''))
    }

    if (sitePages.length) {
      setIsInit(true)
    }
  }, [currentSitePageId, dispatch, id, navigate, roles, sitePages, user])

  return { isInit }
}
